import script from "./SectionTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTitle.vue?vue&type=style&index=0&id=0e88d66c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e88d66c"]])

export default __exports__